"use client"

import { useState } from "react"
import { TaskStatus, type ConvertTaskToRecurringPayload, type Task, type UpdateTaskRecurrencePayload } from "@/schema"
import { Plus } from "lucide-react"
import { toast } from "sonner"

import { useConvertTaskToRecurring } from "@/hooks/api/tasks"
import { MakeRecurringDialog } from "@/components/tasks/make-recurring-dialog"

interface MakeRecurringButtonProps {
  task: Task
  disabled?: boolean
}

export function MakeRecurringButton({ task, disabled }: MakeRecurringButtonProps) {
  const [open, setOpen] = useState(false)
  const convertToRecurring = useConvertTaskToRecurring()

  if (task.task_recurrence || task.status !== TaskStatus.TODO) return null

  const handleSubmit = async (data: ConvertTaskToRecurringPayload | UpdateTaskRecurrencePayload) => {
    await convertToRecurring.mutateAsync({
      taskId: task.id,
      data: {
        ...data,
        recurring_until: data.recurring_until ?? undefined,
      },
    })
    toast.success("Task is now recurring")
    setOpen(false)
  }

  return (
    <>
      <button
        type="button"
        className="text-muted-foreground hover:bg-muted hover:text-foreground focus:outline-primary flex h-8 cursor-pointer items-center gap-1.5 rounded-md px-2 text-sm focus:outline-1"
        disabled={disabled}
        onClick={() => setOpen(true)}
      >
        <Plus className="size-3.5" />
        Make recurring
      </button>

      <MakeRecurringDialog
        task={task}
        open={open}
        onOpenChange={setOpen}
        onSubmit={handleSubmit}
        submitting={convertToRecurring.isPending}
      />
    </>
  )
}
